import config from '@/config'
import Imports, {
  IImport,
  IImportSkoolMembers,
  IImportSkoolPosts,
} from '@/models/Imports'
import Model from '@/models/Model'
import BaseService from './BaseService'
import { requests } from './HTTPService'

const http = requests(config?.COMMUNITIES_SERVER_URL)

export default class ImportService extends BaseService<Imports> {
  protected basePath = ''

  constructor(locationId: string, groupId: string) {
    super(locationId)
    this.basePath = `/${locationId}/groups/${groupId}/imports`
  }

  model(): typeof Model {
    return Imports
  }

  async importSkoolMembers(payload: IImportSkoolMembers): Promise<IImport> {
    const response = await http.post(`${this.basePath}/skool/members`, payload)
    return response.data
  }
  async getLatestImport(): Promise<IImport | null> {
    const response = await http.get(`${this.basePath}/skool/members`)
    return response.data
  }
  async uploadImportFile(payload: {
    auditLogId: string
    uploadedCsvFileUrl: string
  }): Promise<IImport> {
    const response = await http.post(
      `${this.basePath}/skool/sync-members`,
      payload
    )
    return response.data
  }

  async syncAllPosts(payload: IImportSkoolPosts): Promise<IImport> {
    const response = await http.post(`${this.basePath}/skool/posts`, payload)
    return response.data
  }

  async reSyncMembersRequest(payload: {
    auditLogId: string
  }): Promise<IImport> {
    const response = await http.post(
      `${this.basePath}/skool/members/resync`,
      payload
    )
    return response.data
  }
}
